import type {PaymentCard} from '@yandex-delivery/api/model/payment'
import type {RegistrationRequest} from '@yandex-delivery/api/service/registration/types'
import {toUndefined} from '@yandex-delivery/utils'
import {useState} from 'react'

import {
  fetchCardBound,
  fetchCardBoundContext,
  fetchCards,
  fetchNotificationsAgreements,
  fetchRegistration,
} from 'src/shared/api'
import {appConfig} from 'src/shared/config'

import type {Props} from './types'

export function useChangeCardModal({getBody}: Props) {
  // useState вместо useMemo, потому то в документации написано, что useMemo может вызываться повторно
  // тогда как useState гарантирует единственный вызов
  const [state] = useState(() => {
    // возможно getBody стоит положить в useRef, потому что useState сохранит ссылку в замыкании
    const body: RegistrationRequest = Object.assign({country: appConfig.countryCode}, getBody())
    // начинаем скрытую регистрацию пользователя, пока он вводит (или выбирает) данные карты
    // игнорируем ошибки, если что-то пойдет не так, то попробуем еще раз перед привязкой карты
    const registrationPromise = fetchRegistration(body).catch(toUndefined)

    return {
      fetchCardBoundContext,
      fetchCards,
      fetchNotificationsAgreements,
      fetchBoundCard(nextCard: PaymentCard, isNotificationsAllowed: boolean): Promise<PaymentCard> {
        return registrationPromise
          .then(response => {
            // если на старте зарегистрироваться не получилось, то пробуем регистрировать еще раз
            if (response === undefined) {
              return fetchRegistration(body)
            }

            return response
          })
          .then(fetchCardBound(nextCard, appConfig.countryCode, isNotificationsAllowed))
      },
    } as const
  })

  return state
}
